// src/pages/Admin/AdminBlog.jsx
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { blogAPI } from '../../api/blog.js';
import { useToast } from '../../hooks/useToast.js';
import { Button } from '../../components/ui/Button/Button.jsx';
import { Loader } from '../../components/ui/Loader/Loader.jsx';

export const AdminBlog = () => {
  const [posts, setPosts] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [filters, setFilters] = useState({
    status: 'published',
    search: '',
    category: '',
  });
  const { success, error } = useToast();

  useEffect(() => {
    loadPosts();
  }, [filters]);

  const loadPosts = async () => {
    setIsLoading(true);
    try {
      const response = await blogAPI.getAll({ ...filters, limit: 50 });
      setPosts(response.data.data || []);
    } catch (err) {
      error('Не удалось загрузить статьи');
    } finally {
      setIsLoading(false);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Вы уверены?')) return;
    try {
      await blogAPI.delete(id);
      success('Статья удалена');
      loadPosts();
    } catch (err) {
      error('Не удалось удалить статью');
    }
  };

  const handlePublish = async (id, currentStatus) => {
    try {
      const newStatus = currentStatus === 'published' ? 'draft' : 'published';
      await blogAPI.update(id, { status: newStatus });
      success(`Статья ${newStatus === 'published' ? 'опубликована' : 'снята с публикации'}`);
      loadPosts();
    } catch (err) {
      error('Не удалось обновить статус');
    }
  };

  if (isLoading) {
    return <Loader text="Загрузка статей..." />;
  }

  return (
    <div>
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '24px',
        flexWrap: 'wrap',
        gap: '12px',
      }}>
        <div style={{ display: 'flex', gap: '12px', alignItems: 'center', flexWrap: 'wrap' }}>
          <input
            type="text"
            placeholder="Поиск статей..."
            value={filters.search}
            onChange={(e) => setFilters({ ...filters, search: e.target.value })}
            style={{
              padding: '8px 16px',
              borderRadius: '8px',
              border: '1px solid rgb(var(--c-border))',
              fontSize: '14px',
              outline: 'none',
              width: '240px',
            }}
          />
          <select
            value={filters.status}
            onChange={(e) => setFilters({ ...filters, status: e.target.value })}
            style={{
              padding: '8px 12px',
              borderRadius: '8px',
              border: '1px solid rgb(var(--c-border))',
              fontSize: '14px',
              outline: 'none',
            }}
          >
            <option value="">Все статусы</option>
            <option value="published">Опубликованные</option>
            <option value="draft">Черновики</option>
            <option value="archived">Архив</option>
          </select>
          <select
            value={filters.category}
            onChange={(e) => setFilters({ ...filters, category: e.target.value })}
            style={{
              padding: '8px 12px',
              borderRadius: '8px',
              border: '1px solid rgb(var(--c-border))',
              fontSize: '14px',
              outline: 'none',
            }}
          >
            <option value="">Все категории</option>
            <option value="guides">Гайды</option>
            <option value="cases">Кейсы</option>
            <option value="news">Новости</option>
            <option value="tutorials">Обучение</option>
          </select>
        </div>
        <Link to="/admin/blog/new">
          <Button>+ Новая статья</Button>
        </Link>
      </div>

      <div style={{
        backgroundColor: 'rgb(var(--c-surface))',
        borderRadius: '12px',
        overflow: 'hidden',
        boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
      }}>
        <div style={{ overflowX: 'auto' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '14px' }}>
            <thead>
              <tr style={{ backgroundColor: 'rgb(var(--c-bg))' }}>
                <th style={{ padding: '12px 16px', textAlign: 'left' }}>Название</th>
                <th style={{ padding: '12px 16px', textAlign: 'left' }}>Категория</th>
                <th style={{ padding: '12px 16px', textAlign: 'left' }}>Статус</th>
                <th style={{ padding: '12px 16px', textAlign: 'left' }}>Просмотры</th>
                <th style={{ padding: '12px 16px', textAlign: 'right' }}>Действия</th>
              </tr>
            </thead>
            <tbody>
              {posts.map((post) => (
                <tr key={post.id} style={{ borderTop: '1px solid rgb(var(--c-surface-2))' }}>
                  <td style={{ padding: '12px 16px' }}>
                    <Link to={`/admin/blog/${post.id}`} style={{ color: 'rgb(var(--c-text))', textDecoration: 'none' }}>
                      {post.title}
                    </Link>
                  </td>
                  <td style={{ padding: '12px 16px', color: 'rgb(var(--c-text-secondary))' }}>{post.category}</td>
                  <td style={{ padding: '12px 16px' }}>
                    <span style={{
                      padding: '2px 10px',
                      borderRadius: '100px',
                      fontSize: '12px',
                      fontWeight: 500,
                      backgroundColor: post.status === 'published' ? '#D4EDDA' :
                                    post.status === 'archived' ? '#F8D7DA' :
                                    '#FFF3CD',
                      color: post.status === 'published' ? '#155724' :
                             post.status === 'archived' ? '#721C24' :
                             '#856404',
                    }}>
                      {post.status === 'published' ? 'Опубликована' :
                       post.status === 'draft' ? 'Черновик' :
                       'Архив'}
                    </span>
                  </td>
                  <td style={{ padding: '12px 16px', color: 'rgb(var(--c-text-secondary))' }}>{post.view_count || 0}</td>
                  <td style={{ padding: '12px 16px', textAlign: 'right' }}>
                    <div style={{ display: 'flex', gap: '8px', justifyContent: 'flex-end' }}>
                      <button
                        onClick={() => handlePublish(post.id, post.status)}
                        style={{
                          background: 'none',
                          border: 'none',
                          cursor: 'pointer',
                          fontSize: '18px',
                        }}
                        title={post.status === 'published' ? 'Снять с публикации' : 'Опубликовать'}
                      >
                        {post.status === 'published' ? '📤' : '📥'}
                      </button>
                      <Link to={`/admin/blog/${post.id}`} style={{ textDecoration: 'none' }}>
                        <button
                          style={{
                            background: 'none',
                            border: 'none',
                            cursor: 'pointer',
                            fontSize: '18px',
                            color: 'rgb(var(--c-accent))',
                          }}
                          title="Редактировать"
                        >
                          ✏️
                        </button>
                      </Link>
                      <button
                        onClick={() => handleDelete(post.id)}
                        style={{
                          background: 'none',
                          border: 'none',
                          cursor: 'pointer',
                          fontSize: '18px',
                          color: 'rgb(var(--c-danger))',
                        }}
                        title="Удалить"
                      >
                        🗑️
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};